<template>
  <div class="center">
    <van-popup v-model="yins" @close="closes()" round closeable>
      <div
        class="invitePop"
        @touchstart="touchSatrt"
        @touchmove="touchMove"
        @touchend="touchEnd"
        id="inner"
        style="
          width: 70vw;
          height: 80vh;
          overflow-y: scroll;
          padding-top: 34px;
          background: #fff;
        "
      >
        <h3 style="text-align: center">酷炫脑用户协议</h3>
        <div
          style="
            font-size: 12px;
            min-height: 100vh;
            padding: 15px;
            line-height: 20px;
            text-align: left;
          "
        >
          &nbsp&nbsp&nbsp&nbsp（以下杭州虎头虎脑科技有限公司简称“本公司”）按照下列条款与条件提供信息和产品，您在本协议中亦可被称为“用户”，以下所述条款和条件将构成您与本公司，就您使用提供的内容所达成的全部协议（以下称“本协议”）。<br />
          说明本公司向您提供包括但不限于测评下载、使用、充值、客户服务、测评资讯、论坛交流等服务（以下称“本服务”）。本公司针对本服务所制定的相关规定，包括但不限于本公司在测评平台下运营的任何一款测评所包含的测评规则、用户处罚条例，客服条例等，以及本公司就账号使用及管理、测评充值等服务制定的相关服务协议、规则。本公司在此提示用户，请您在使用本服务前详细阅读本协议的所有内容，尤其是免除、限制本公司责任或者限制用户权利的条款（特别是粗体下划线标注的内容），如您对本协议有任何疑问，请向本公司进行咨询。一旦您使用本服务，即表示您已阅读并完全同意接受本协议项下所述条款和条件的约束。如果您不同意本协议的任何条款，请您不要使用本服务。未成年人应经其监护人陪同阅读本服务协议并表示同意，方可接受本服务协议。监护人应加强对未成年人的监督和保护，因其未谨慎履行监护责任而损害未成年人利益或者本公司利益的，应由监护人承担责任。
          <br />&nbsp&nbsp&nbsp&nbsp<strong>权利声明</strong><br />
          一、本公司及其关联公司（关联企业指与本公司存在直接或间接，股权或以协议安排等其他形式的控制与被控制关系，以及对公司运营具有重大影响关系的公司法人）享有并保留以下各项内容完整的、不可分割的所有权及/或知识产权：<br />
          （1）测评平台相关的软件、技术、程序、代码、用户界面等；<br />
          （2）本服务相关的商标、图形标记。<br />
          二、本公司提供的服务内容中所涉及的测评，文字、软件、声音、图片、动画、录像、图表等，均受相关知识产权法以及其他相关法律的保护。未经本公司或者其他相关权利人授权，用户不得复制、使用、修改、摘编、翻译、发行,第三方未经本公司及/或其相关权利人的书面许可，不得以任何方式擅自进行使用。<br />
          <strong>责任限制 </strong><br />
          &nbsp&nbsp&nbsp&nbsp1、本公司向用户提供的服务均是在依"现状"提供，本公司在此明确声明对本服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性、准确性、及时性、可持续性等。<br />
          &nbsp&nbsp&nbsp&nbsp2、用户理解并同意自行承担使用本服务的风险，且用户在使用本服务时，应遵循中国法律的相关规定，由于用户行为所造成的任何损害和后果，本公司均不承担除法律有明确规定外的责任。<br />
          &nbsp&nbsp&nbsp&nbsp3、不论在何种情况下，本公司均不对由于网络连接故障、通讯线路、第三方网站、电脑硬件等任何原因给用户造成的任何损失承担除法律有明确规定外的责任。
          <strong>用户行为规范</strong><br />
          &nbsp&nbsp&nbsp&nbsp
          1、用户在本网站注册时，不得使用虚假身份信息。用户应当妥善保存其账户信息和密码，由于用户泄密所导致的损失需由用户自行承担。如用户发现他人冒用或盗用其账户或密码，或其账户存在其他未经合法授权使用之情形，应立即以有效方式通知本公司。用户理解并同意本公司有权根据用户的通知、请求或依据判断，采取相应的行动或措施，包括但不限于冻结账户、限制账户功能等，本公司对采取上述行动所导致的损失不承担除法律有明确规定外的责任。
          <br />&nbsp&nbsp&nbsp&nbsp2、用户在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：
          <br />&nbsp&nbsp&nbsp&nbsp（1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；
          <br />&nbsp&nbsp&nbsp&nbsp（2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；
          <br />&nbsp&nbsp&nbsp&nbsp（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；
          <br />&nbsp&nbsp&nbsp&nbsp（4）发布、传送、传播广告信息及垃圾信息；
          <br />&nbsp&nbsp&nbsp&nbsp（5）其他法律法规禁止的行为。
          <br />&nbsp&nbsp&nbsp&nbsp3、用户不得利用本服务进行任何有损本公司及其关联企业之权利、利益及商誉，或其他用户合法权利之行为。
          <br />
          &nbsp&nbsp&nbsp&nbsp4、用户不得基于本服务从事制作、使用、传播“私服”、“外挂”等侵害本公司合法权益的行为。如有违反，本公司将依据中国现行法律法规及本公司的相关规定予以处理。
          <br />&nbsp&nbsp&nbsp&nbsp5、虚拟财产转移服务外，用户不得通过任何方式直接或变相进行测评账号、测评币、测评道具等虚拟财产的转移。
          <br />&nbsp&nbsp&nbsp&nbsp6、用户不得从事作弊等损害测评公平性的行为。用户承诺接受本公司对其测评数据进行分析，当本公司发现其数据异常时，本公司可根据自己的独立判断认定其为作弊。
          <br />&nbsp&nbsp&nbsp&nbsp7、用户不得从事任何利用本公司平台系统漏洞进行有损其他用户、本公司或互联网安全的行为。
          <br />&nbsp&nbsp&nbsp&nbsp8、用户知悉并确认，本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式，向用户发出关于本服务的通知、规则、提示等信息，均为有效通知。该等信息一经公布或发布，即视为已送达至用户。
          <br /><strong> 广告信息和促销</strong> <br />
          &nbsp&nbsp&nbsp&nbsp1、用户同意接受本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式发送的有关本服务，或本公司、本公司之关联企业或与本公司有合作关系的第三方相关的商品、服务促销或其他商业信息。
          <br />&nbsp&nbsp&nbsp&nbsp2、本公司在本服务中可能提供与其他互联网之网站站点或资源的链接，本公司对存在或源于此类网站站点或资源的任何内容、广告、产品或其他资料不予保证或负责；如该链接所载的内容或搜索引擎所提供之链接的内容侵犯用户权利，本公司声明与上述内容无关，且不承担除法律有明确规定外的责任。
        </div>
      </div>
    </van-popup>
    <van-popup v-model="yins1" @close="closes1()" round closeable>
      <div
        class="invitePop"
        @touchstart="touchSatrt1"
        @touchmove="touchMove1"
        @touchend="touchEnd1"
        id="inner1"
        style="
          width: 70vw;
          height: 80vh;
          overflow-y: scroll;
          padding-top: 34px;
          background: #fff;
        "
      >
        <h3 style="text-align: center">隐私协议</h3>
        <div
          style="
            font-size: 12px;
            padding: 15px;
            line-height: 20px;
            text-align: left;
          "
        >
          <p><strong>&nbsp&nbsp&nbsp&nbsp隐私条款：</strong></p>
          <p>
            &nbsp&nbsp&nbsp&nbsp本公司非常重视用户的隐私保护，因此制定了本涵盖如何收集、使用、披露、分享以及存储用户的信息的《隐私条款》。
            用户在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私条款》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
            本《隐私条款》适用于用户与本测评的交互行为以及用户注册和使用本测评的服务，我们建议您仔细地阅读本政策，以帮助您了解维护自己隐私权的方式。
            您使用或继续使用我们的服务，即表示您同意我们按照本《隐私条款》收集、使用、储存和分享您的相关信息。如对本《隐私条款》或相关事宜有任何问题，请进行留言。
          </p>
          <p><strong>&nbsp&nbsp&nbsp&nbsp一、我们可能收集的信息</strong></p>
          <p>
            &nbsp&nbsp&nbsp&nbsp我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
          </p>
          <p>（一）您提供的信息</p>
          <p>
            &nbsp&nbsp&nbsp&nbsp1、您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、身份证明、电子邮件等；
          </p>
          <p>
            &nbsp&nbsp&nbsp&nbsp2、如您使用我们的服务需与用户的银行账户或其他支付工具的账户关联方能实现时，您向我们提供您的银行账户信息或其他支付工具的账户信息；
          </p>
          <p>
            &nbsp&nbsp&nbsp&nbsp3、您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
          </p>
          <p>（二）其他方分享的您的信息</p>
          其他方使用我们的服务时所提供有关您的共享信息。
          <p>（三）我们获取的您的信息</p>

          <p>
            （1）日志信息，指您使用我们的服务时，系统自动采集的技术信息，包括：<br />
            &nbsp&nbsp&nbsp&nbspo 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；<br />
            &nbsp&nbsp&nbsp&nbspo 在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；<br />
            &nbsp&nbsp&nbsp&nbspo 有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；<br />
            &nbsp&nbsp&nbsp&nbspo 您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；<br />
            &nbsp&nbsp&nbsp&nbspo 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
          </p>
          <p>
            （2）位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：<br />
            &nbsp&nbsp&nbsp&nbspo 您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；<br />
            &nbsp&nbsp&nbsp&nbspo 您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；<br />
            &nbsp&nbsp&nbsp&nbspo 您可以通过关闭定位功能，停止对您的地理位置信息的收集。
          </p>
          <p><strong>&nbsp&nbsp&nbsp&nbsp二、我们如何使用您的信息</strong></p>
          <p>
            （一）我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：<br />
            &nbsp&nbsp&nbsp&nbsp1、向您提供服务。在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；<br />
            &nbsp&nbsp&nbsp&nbsp2、帮助我们设计新服务，改善我们现有服务；<br />
            &nbsp&nbsp&nbsp&nbsp3、使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；<br />
            &nbsp&nbsp&nbsp&nbsp4、向您提供与您更加相关的广告以替代普遍投放的广告；<br />
            &nbsp&nbsp&nbsp&nbsp5、评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；<br />
            &nbsp&nbsp&nbsp&nbsp6、软件认证或管理软件升级；
            <br />&nbsp&nbsp&nbsp&nbsp7、让您参与有关我们产品和服务的调查。
          </p>
          <p>
            （二）为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
          </p>
          <p>
            <strong
              >&nbsp&nbsp&nbsp&nbsp三、您如何访问和控制自己的个人信息</strong
            >
          </p>
          <p>
            &nbsp&nbsp&nbsp&nbsp我们将尽量采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
          </p>
          <p><strong>&nbsp&nbsp&nbsp&nbsp四、我们如何分享您的信息</strong></p>
          除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：
          <p>
            &nbsp&nbsp&nbsp&nbsp（一）我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：<br />
            &nbsp&nbsp&nbsp&nbspo 向您提供我们的服务；
            o 实现“我们可能如何使用信息”部分所述目的；<br />
            &nbsp&nbsp&nbsp&nbspo 履行我们在本《隐私条款》或本测评与您达成的其他协议中的义务和行使我们的权利；<br />
            &nbsp&nbsp&nbsp&nbspo 理解、维护和改善我们的服务。<br />
            如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私条款》及我们要求其遵守的其他适当的保密和安全措施。<br />
          </p>

          <p>
            &nbsp&nbsp&nbsp&nbsp（二）随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
          </p>
          <p>
            &nbsp&nbsp&nbsp&nbsp（三）我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：
          </p>
          &nbsp&nbsp&nbsp&nbspo 您授权或同意本测评披露的；
          o 遵守适用的法律法规；<br />
          &nbsp&nbsp&nbsp&nbspo 遵守法院命令或其他法律程序的规定；
          o 遵守相关政府机关的要求；<br />
          &nbsp&nbsp&nbsp&nbspo 为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；<br />
          &nbsp&nbsp&nbsp&nbspo 根据本测评各服务条款及声明中的相关规定，或者本测评认为必要的其他情形下。<br />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" @close="close()" round>
      <div class="pop1">
        <img class="pop-img1" v-lazy="resBgImg" />
        <div class="popFt">
          <van-button type="warning" @click="goVip()" class="popbtn"
            >开通会员</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="show = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <!-- 头部 -->
    <header>
      <div class="beijin"></div>
      <div class="mytop">
        <div class="fcc mt-10 user">
          <img v-lazy="user.avatar" class="image" />
        </div>
        <div class="myintr mt-10">
          <p class="name f16">
            {{
              user.nick_name && user.nick_name.length > 10
                ? user.nick_name.slice(0, 10) + "..."
                : user.nick_name
            }}
            <span v-if="isVip" class="vip ml-5"></span>
            <span v-if="!isVip" class="vip-no ml-5"></span>
          </p>
          <p v-if="isVip" style="margin-top: 5px">
            会员有效期至： {{ endTime.split(" ")[0] }}
            <span style="color: #f5a623" @click="goVip">续费 ></span>
          </p>
          <p
            v-else
            class="mt-10 f14 mr-5"
            style="color: #f5a623"
            @click="goVip"
          >
            充值会员 >
          </p>
          <router-link :to="'/my/invite'">
            <p class="myinter">我的邀请</p>
          </router-link>
        </div>
        <div class="mydetail mt-10" @click="goInfo">个人信息</div>
      </div>
    </header>

    <!-- 主体 -->
    <main class="mt-20">
      <van-row style="margin-bottom: 41px; margin-top: 41px">
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/myTest'">
            <img v-lazy="require('../../../assets/img/my/report.png')" />
            <p>我的报告</p>
          </router-link>
        </van-col>
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/myOrder'">
            <img v-lazy="require('../../../assets/img/my/order.png')" />
            <p>我的订单</p>
          </router-link>
        </van-col>
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/collection'">
            <img v-lazy="require('../../../assets/img/my/collection.png')" />
            <p>我的收藏</p>
          </router-link>
        </van-col>
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/evaluation'">
            <img v-lazy="require('../../../assets/img/my/evaluation.png')" />
            <p>我的评价</p>
          </router-link>
        </van-col>
      </van-row>
      <van-row class="mt-10">
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/send'">
            <img v-lazy="require('../../../assets/img/my/send.png')" />
            <p>赠送兑换</p>
          </router-link>
        </van-col>
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/coupon'">
            <img v-lazy="require('../../../assets/img/my/coupon.png')" />
            <p>优惠券</p>
          </router-link>
        </van-col>

        <van-col span="6" class="tac f14">
          <router-link :to="'/my/myServer'">
            <img v-lazy="require('../../../assets/img/my/service.png')" />
            <p>我的客服</p>
          </router-link>
        </van-col>
        <van-col span="6" class="tac f14">
          <router-link :to="'/my/myGold'">
            <img v-lazy="require('../../../assets/img/my/gold.png')" />
            <p>奖励收入</p>
          </router-link>
        </van-col>
      </van-row>
    </main>
    <div class="mt-30 ml-10">
      <div style="display: flex; justify-content: space-between">
        <p class="h1 myText">我的测评</p>
        <span
          style="display: flex; flex-direction: column-reverse"
          @click="goAllTest()"
        >
          <div class="check_more_test" style="color: #42686e">
            查看更多<img
              style="width: 7px; height: 9px; margin-left: 1px"
              v-lazy="require('../../../assets/img/test/right.png')"
            />
          </div>
        </span>
      </div>
      <div v-if="!myTestsLen" class="noTest">
        <img
          v-lazy="require('../../../assets/img/test/no_test.png')"
          style="height: 104px; width: 70px"
        />
        <p class="ft16 bold">这里暂时什么都没有</p>
        <p class="f14 mt-10" style="color: #42686e" @click="goHome">
          先去主页逛逛吧 >
        </p>
      </div>

      <div class="content">
        <div class="wrapper">
          <div
            class="in-wrapper f14"
            v-for="item in myTests"
            :key="item.id"
            @click="godetail(item.evaluation.id)"
          >
            <div class="imgBox">
              <img v-lazy="item.evaluation.home_image" class="bdr8" />
            </div>
            <p style="line-height: 16px">{{ item.evaluation.title }}</p>
            <p class="mt-5">
              <span class="yellow">￥{{ item.evaluation.discount_price }}</span>
              <s class="discount">￥{{ item.evaluation.original_price }}</s>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="xieyi">
      <span class="colors" @click="yins = true">酷炫脑用户协议</span>和<span
        class="colors"
        @click="yins1 = true"
        >隐私协议</span
      >
    </div>
    <Footer page="my" />
  </div>
</template>

<script>
let startY,
  y,
  aboveY = 0,
  startY1,
  y1,
  aboveY1 = 0;
import Footer from "@/components/Footer";
import store from "./../../../store/index";
import { mapGetters } from "vuex";
import { getMyTest, getUserInfo } from "@/http/api";
export default {
  data() {
    return {
      isVip: false,
      endTime: "",
      // 热门测评
      myTests: [],
      myTestsLen: 0,
      // 弹窗
      showcs: true,
      yins: false,
      yins1: false,
      closeImg: require("./../../../assets/img/test/close.png"),
      resBgImg: require("./../../../assets/img/test/bevip.png"),
      show: localStorage.vipPopShow != new Date().getDate(),
      // show: false,
      showPop: {
        image: require("./../../../assets/img/test/vipPop.jpg"),
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  // watch() {
  // },
  created() {
    console.log(this.$store);
    let pro = this.user;
    getUserInfo(pro.user).then((res) => {
      console.log(res);
      const payload = res.data.profile;
      store.commit("updateUser", payload);
      if (payload.is_vip.key === "yes") {
        this.isVip = true;
        this.endTime = payload.valid_date;
        this.show = false;
        // localStorage.setItem('vipPopShow', new Date().getDate())
      }
    });
    let params = {
      page: 1,
      page_size: 10,
    };
    getMyTest(params).then((res) => {
      console.log(res);
      if (res.data.hasOwnProperty("objects")) {
        this.myTests = res.data.objects;
        this.myTestsLen = this.myTests.length;
      }
    });
    localStorage["first"] = "";
  },
  methods: {
    touchSatrt(e) {
      //触摸

      e.preventDefault();
      var touch = e.touches[0];
      console.log(1);
      startY = touch.pageY; //刚触摸时的坐标
    },

    touchMove(e) {
      //滑动
      let inner = document.getElementById("inner");
      e.preventDefault();
      var touch = e.touches[0];
      y = touch.pageY - startY; //滑动的距离
      //inner.style.webkitTransform = 'translate(' + 0+ 'px, ' + y + 'px)';  //也可以用css3的方式
      inner.scrollTop = aboveY - y; //这一句中的aboveY是inner上次滑动后的位置
    },

    touchEnd(e) {
      //手指离开屏幕
      let inner = document.getElementById("inner");
      e.preventDefault();
      aboveY = parseInt(inner.scrollTop); //touch结束后记录内部滑块滑动的位置 在全局变量中体现 一定要用parseInt()将其转化为整数字;
    },
    touchSatrt1(e) {
      //触摸

      e.preventDefault();
      var touch = e.touches[0];
      console.log(1);
      startY1 = touch.pageY; //刚触摸时的坐标
    },

    touchMove1(e) {
      //滑动
      let inner = document.getElementById("inner1");
      e.preventDefault();
      var touch = e.touches[0];
      y1 = touch.pageY - startY1; //滑动的距离
      //inner.style.webkitTransform = 'translate(' + 0+ 'px, ' + y + 'px)';  //也可以用css3的方式
      inner.scrollTop = aboveY1 - y1; //这一句中的aboveY是inner上次滑动后的位置
    },

    touchEnd1(e) {
      //手指离开屏幕
      let inner = document.getElementById("inner1");
      e.preventDefault();
      aboveY1 = parseInt(inner.scrollTop); //touch结束后记录内部滑块滑动的位置 在全局变量中体现 一定要用parseInt()将其转化为整数字;
    },

    closes() {
      this.yins = false;
    },
    closes1() {
      this.yins1 = false;
    },
    // 进入全部测评页
    goInfo() {
      this.$router.push("./set");
    },
    goAllTest() {
      this.$router.push("./myTest/all");
    },
    // 查看测试
    godetail(index) {
      store.commit("set_eval_id", index);
      this.$router.push("../test/" + index);
    },
    // 进入主页
    goHome() {
      this.$router.push("./../index");
    },
    goVip() {
      if (!localStorage["site_current_token"]) {
        this.$router.push("/login");
      } else {
        this.show = false;
        localStorage.setItem("vipPopShow", new Date().getDate());
        this.$router.push("./vip");
      }
    },
    // 关闭弹窗
    close() {
      this.show = false;
      localStorage.setItem("vipPopShow", new Date().getDate());
    },
  },
  components: {
    Footer,
  },
};
</script>

<style lang="less" scoped>
@import "./center.less";
// @import "~Style/index.less";
.van-popup {
  overflow-y: hidden;
}
.xieyi {
  // margin-top: 20px;
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #9b9b9b;
  line-height: 18px;
  text-align: center;
}
.colors {
  color: #42686e;
}
.mytop {
  display: flex;
  margin: 25px 19px;
}

.myintr {
  flex: 1;
  padding: 4px 5px;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*不换行*/
  /*超出部分文字以...显示*/
  font-size: 10px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 10px;

  .name {
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4a4a4a;
    margin-bottom: 9px;
  }
}

.myinter {
  margin-top: 12px;
  width: 78px;
  height: 20px;
  border-radius: 8px;
  border: 1px solid #979797;
  text-align: center;
  line-height: 20px;

  font-size: 12px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #4a4a4a;
}

.mydetail {
  width: 70px;
  height: 35px;
  background: #42686e;
  border-radius: 30px;
  margin-top: 24px;

  font-size: 12px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 35px;
  text-align: center;
}

.myText {
  color: #4a4a4a;
  font-size: 18px;
  margin-left: 10px;
}

// .more {
//   color: #9b9b9b;
//   font-size: 14px;
//   font-weight: normal;
// }

.check_more_test {
  /*margin-top: 60px;*/
  margin-bottom: 10px;
  margin-right: 10px;
  font-size: 14px;
  line-height: 37px;
  color: #7487c3;
}

/*.check_more_box{*/
/*  margin-right: 10px;*/
/*  display: flex;*/
/*  flex-direction: column-reverse;*/
/*}*/

.pop1 {
  margin-top: -17px;
  border-radius: 24px;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .pop-img1 {
    width: 8.14rem;
    // border-radius: 0.5rem;
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    // line-height: 1.09rem;
    margin-top: -30px;
    padding-top: 40px;
    padding-bottom: 0.14rem;
    background: #fff;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    // line-height: 0.41rem;
    letter-spacing: 1px;
    padding-bottom: 14px;
    background: #fff;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;
    padding-bottom: 44px;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .closeImg {
    height: 30px;
    width: 30px;
    margin: 0 auto;
  }

  .popFt {
    text-align: center;
    margin-top: -34px;

    margin-bottom: 20px;

    .popbtn {
      width: 80%;
      background-color: #42686e;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
      border: none;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  .reduce {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .reduce-1 {
    display: inline-block;
    background: url("./../../../assets/img/test/reduce-1.png") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  .number {
    vertical-align: super;
    margin-top: -10px;
    display: inline-block;
    padding: 5px;
  }

  .add {
    display: inline-block;
    background: url("./../../../assets/img/test/add.jpg") no-repeat center
      center;
    background-size: 100%, 100%;
    width: 25px;
    height: 25px;
  }

  img {
    width: 8.8rem;
    border-radius: 0.5rem;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}
</style>
